import { inject, observer } from "mobx-react";
import React from "react";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core";

export const nestedStyles = (theme: Theme) =>
  createStyles({
    firstLine: {
      display: "block",
      gridTemplateColumns: "35% 62%",
      columnGap: "3%",
      gridColumnGap: `${theme.spacing(3)}`,

      [theme.breakpoints.down("lg")]: {
        gridTemplateColumns: "100%"
      }
    },
    secondLine: {
      display: "block",
      gridTemplateColumns: "100%",
      gridColumnGap: `${theme.spacing(3)}`
    },
    gridItem: {}
  });

export interface NestedViewProps extends WithStyles<typeof nestedStyles> {
  showView: any;
  indexView: any;
}

@inject("router", "commons")
@observer
export class NestedViewComponent extends React.Component<NestedViewProps> {
  public constructor(props: NestedViewProps) {
    super(props);
  }

  public render() {
    const { showView, indexView, classes } = this.props;

    return (
      <div className={classes.firstLine}>
        <div className="props.classes.gridItem">{showView}</div>
        <div className={classes.secondLine}>{indexView}</div>
      </div>
    );
  }
}

export const NestedView = withStyles(nestedStyles, { withTheme: true })(
  NestedViewComponent
);
